const unitEqual = [
  { sku: 'BFruAlbarikg', name: 'Albaricoques kg', und: 0.17 },
  { sku: 'BFruCaquikg', name: 'Caqui kg', und: 0.25 },
  { sku: 'BFruCarambkg', name: 'Carambola kg', und: 0.1 },
  { sku: 'BFruChirimkg', name: 'Chirimoya kg', und: 0.2 },
  { sku: 'BFruGranaKg', name: 'Granada kg', und: 0.33 },
  { sku: 'BFruKiwikg', name: 'Kiwi kg', und: 0.13 },
  { sku: 'BFruKiwiZespkg', name: 'Kiwi Zespri kg', und: 0.13 },
  { sku: 'LimaCat1KG', name: 'Lima (cat 1) kg', und: 0.1, caja: 4.5 },
  { sku: 'LimaCat2KG', name: 'Lima (cat 2) kg', und: 0.1, caja: 4.5 },
  { sku: 'BFruLiKafkg', name: 'Lima Kaffir kg', und: 0.08 },
  { sku: 'BLEMEkg', name: 'Limón para Mesa kg', und: 0.17, caja: 10 },
  { sku: 'BLEZUkg', name: 'Limón para Zumo kg', und: 0.17, caja: 10 },
  { sku: 'FruLuloNaranKG', name: 'Lulo (naranjilla) kg', und: 0.15 },
  { sku: 'BFruMandarinakg', name: 'Mandarina kg', und: 0.15 },
  { sku: 'BFruMangAVkg', name: 'Mango de Avion kg', und: 0.5 },
  { sku: 'BFruMangoDURkg', name: 'Mango Normal kg', und: 0.5 },
  { sku: 'BFruManzFugiKG', name: 'Manzana Fuji kg', und: 0.2 },
  { sku: 'BFruManzGolKG', name: 'Manzana Golden kg', und: 0.2 },
  { sku: 'BFruManzGrSmiKG', name: 'Manzana Granny Smith', und: 0.2 },
  { sku: 'BFruManzRojKG', name: 'Manzana Roja kg', und: 0.2 },
  { sku: 'BFruMarackg', name: 'Maracuya (pasion fruit) kg', und: 0.08 },
  { sku: 'BFruMaracPremkg', name: 'Maracuya (pasion fruit) Premium kg', und: 0.8 },
  { sku: 'FruPassionFrOsckg', name: 'Fruta de la pasión (morada) kg', und: 0.8 },
  { sku: 'BFruMelocotonkg', name: 'Melocotón kg', und: 0.12 },
  { sku: 'BFruMelocNectkg', name: 'Melocotón Nectarina kg', und: 0.1 },
  { sku: 'BFruMelocParkg', name: 'Melocotón Paraguayo kg', und: 0.08 },
  { sku: 'BFruMelonCankg', name: 'Melón Cantalupo kg', und: 1.2 },
  { sku: 'BFruMELONKg', name: 'Melón kg', und: 3 },
  { sku: 'FruMelSapkg', name: 'Melón Sapo kg', und: 3 },
  { sku: 'NarExtraKG', name: 'Naranja Extra (para piel) kg', und: 0.35 },
  { sku: 'BNarMesKG', name: 'Naranja para Mesa kg', und: 0.35 },
  { sku: 'BNarZumKG', name: 'Naranja para Zumo kg', und: 0.2 },
  { sku: 'BNarZum5CalKG', name: 'Naranja para Zumo 5 Calibre kg', und: 0.17, caja: 15 },
  { sku: 'BNarSangKG', name: 'Naranja Sanguina kg', und: 0.17 },
  { sku: 'BFruPapayakg', name: 'Papaya kg', und: 1.2 },
  { sku: 'BFruPeraConfkg', name: 'Pera Conferencia kg', und: 0.2 },
  { sku: 'BFruPerakg', name: 'Pera kg', und: 0.15 },
  { sku: 'BFruPinaKG', name: 'Piña kg', und: 2 },
  { sku: 'BFruPlatCanKg', name: 'Plátano Canario kg', und: 0.15 },
  { sku: 'BFruPlaMachkg', name: 'Plátano Macho (Africano) kg', und: 0.25 },
  { sku: 'BFruPlataKG', name: 'Plátano Normal (Banana) kg', und: 0.17 },
  { sku: 'BFruPomelKG', name: 'Pomelo kg', und: 0.33 },
  { sku: 'FruSandiFashKg', name: 'Sandia Fashion kg', und: 4.5 },
  { sku: 'BFruSandiKg', name: 'Sandía Rayada kg', und: 4.5 },
  { sku: 'FruSandiaSinPepKG', name: 'Sandía sin Pepitas kg', und: 4.5 },
  { sku: 'AAGHkg', name: 'Aguacate Hass kg', und: 0.2, caja: 4 },
  { sku: 'AAGEttinKG', name: 'Aguacate Verde Liso kg', und: 0.3 },
  { sku: 'BVerAjokg', name: 'Ajo Seco kg', und: 0.1 },
  { sku: 'BVerAlcachofakg', name: 'Alcachofas kg', und: 0.3 },
  { sku: 'BVerBerenjenakg', name: 'Berenjena kg', und: 0.25 },
  { sku: 'BVerBONIAKg', name: 'Boniato kg', und: 0.33 },
  { sku: 'BVerCalabacinkg', name: 'Calabacín kg', und: 0.25 },
  { sku: 'BVerCalHOKkg', name: 'Calabaza Hokkaido kg', und: 1.5 },
  { sku: 'BVerCalabazakg', name: 'Calabaza kg', und: 3 },
  { sku: 'BVerCalVioKG', name: 'Calabaza Violin kg', und: 2.5 },
  { sku: 'BCebBlakg', name: 'Cebolla Gorda Blanca kg', saco: 25 },
  { sku: 'BCebMorkg', name: 'Cebolla Morada (Roja) kg', caja: 10 },
  { sku: 'BSETChampLAMtar250', name: 'Champiñones Laminados tarr 250gr', caja: 8 },
  { sku: 'BSETChampCortdkg', name: 'Champiñones Pie Cortado kg', caja: 2 },
  { sku: 'DORSetasPORTkg', name: 'Setas ( champiñones ) Portobello kg', caja: 2.5 },
  { sku: 'BVerColChinkg', name: 'Col China (Napa) kg', und: 1.5 },
  { sku: 'BVerColLOMBKG', name: 'Col Lombarda (Morada) kg', und: 2 },
  { sku: 'BVerColREPkg', name: 'Col Repollo Valenciana (Blanca) kg', und: 2 },
  { sku: 'BVerDaikoKg', name: 'Daikon kg', und: 1 },
  { sku: 'BVerHinFrekg', name: 'Hinojo Fresco kg', und: 0.25 },
  { sku: 'BVerJengkg', name: 'Jengibre Fresco kg', und: 0.2 },
  { sku: 'DORMaizFrkg', name: 'Maíz Fresco kg', und: 0.2 },
  { sku: 'BPatAGRkg', name: 'Patata Agria kg', saco: 25 },
  { sku: 'BPatMONkg', name: 'Patata Monalisa Agata kg', saco: 15 },
  { sku: 'BVerPEPHolKg', name: 'Pepino Holandes kg', und: 0.3 },
  { sku: 'BVerPepinKG', name: 'Pepino kg', und: 0.25 },
  { sku: 'BPimAmaKG', name: 'Pimiento Dulce Amarillo kg', und: 0.33 },
  { sku: 'BPimRojKG', name: 'Pimiento Dulce Rojo kg', und: 0.33 },
  { sku: 'BPimVerKG', name: 'Pimiento Dulce Verde kg', und: 0.33 },
  { sku: 'BPimITAkg', name: 'Pimiento Italiano kg', und: 0.25 },
  { sku: 'VerPuerroKG', name: 'Puerro kg', und: 0.33 },
  { sku: 'BVerRemolakg', name: 'Remolacha kg', und: 0.15 },
  { sku: 'VerTomCorBuekg', name: 'Tomate Corazon de Buey kg', und: 0.25 },
  { sku: 'BTomDanEnsKG', name: 'Tomate Daniela Ensalada kg', und: 0.17 },
  { sku: 'BTomKumkg', name: 'Tomate Kumato kg', und: 0.14 },
  { sku: 'BTomPerkg', name: 'Tomate Pera kg', und: 0.14 },
  { sku: 'BTomRamkg', name: 'Tomate Rama kg', und: 0.14 },
  { sku: 'BVerYucakg', name: 'Yuca (Mandioca) kg', und: 0.25 },
  { sku: 'BVerZanahkg', name: 'Zanahoria kg', und: 0.25 },
  { sku: 'FruGuayImportKg', name: 'Guayaba Importación kg', und: 0.17 },
  { sku: 'BFruGuayaKg', name: 'Guayaba Nacional kg', und: 0.17 },
  { sku: 'BFruCIRUEKg', name: 'Ciruela kg', und: 0.13 },
  { sku: 'BGuiROJCaja2,5kg', name: 'Chile Rojo Guindilla Fresca kg - caja 2,5kg', caja: 2.5 },
  { sku: '34810', name: 'Pechugas de Pollo s/inyectar kg-caja 5kg', caja: 5 },
  { sku: '45806', name: 'Contramuslo de Pollo Amarillo s/hueso s/piel (Halal) kg - band.aprox.1,5kg', band: 1.5 },
  { sku: '40019', name: 'Bacon Ahumado Moldeado (Mitades) kg - caja/2pz aprox 2kg', caja: 2 },
  { sku: '34303', name: 'Pelotas Burger Meat Mixtas (Albóndigas Cerdo y Vacuno) ±30g/und kg-caja 5kg', caja: 5 },
  { sku: '34812', name: 'Cuartos pollo ±350gr/und kg-caja 10kg', caja: 10 },
  { sku: 'DHuevosM30', name: 'Huevos M band 30 und', caja: 6, band: 1 },
  { sku: 'DHuevosL30', name: 'Huevos L band 30 und', caja: 6, band: 1 },
  { sku: 'BBroGUItar100', name: 'Brotes de Guisantes tarr', caja: 16 },
  { sku: 'IVLZuFManzGrSm250ml', name: 'Zumos Frescos de Manzana Granny Smith IVL 250ml', und: 0.25, caja: 10 },
  { sku: '45807', name: 'Contramuslo de Pollo FR s/hueso c/piel kg - band.aprox.1,5kg', und: 1.5 },
  { sku: '45806', name: 'Contramuslo de Pollo FR s/hueso s/piel kg - band.aprox.1,5kg', und: 1.5 },
  { sku: 'VerTomRBarMaFeoDLTkg', name: 'Tomate Rosa Barbastro Marca Feo de la Tudela kg', und: 0.2 },
  { sku: 'VerTomRBarMarLitkg', name: 'Tomate Rosa Barbastro Marca Llitera kg', und: 0.25 },
]

export default unitEqual
